const a = {
  code: "tl",
  facebook: "tl_PH",
  label: "Tagalog",
  loadingText: "Naglo-load...",
  moment: "tl-ph",
  aliases: ["fil"],
  translations: {
    ar: "Arabe",
    de: "Aleman",
    en: "Ingles",
    es: "Espanyol",
    fr: "Pranses",
    he: "Hebreo",
    hi: "Hindi",
    id: "Indonesyo",
    it: "Italyano",
    ja: "Hapones",
    km: "Khmer",
    ko: "Koreano",
    lo: "Lao",
    ms: "Malayo",
    nl: "Dutch",
    pt: "Portuges",
    ru: "Ruso",
    th: "Thai",
    tl: "Tagalog",
    tr: "Turko",
    vi: "Vietnamese",
    "zh-CN": "Tsino (Pinasimple)",
    "zh-TW": "Tsino (Tradisyonal)"
  }
};
export {
  a as tagalog
};
